import { Fragment, ReactElement, useMemo } from 'react';
import { EditNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { EditNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { EditNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { EditNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { EditNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import EditNotificationsShared from '../../research-notifications/edit';

interface EditNotificationsCivilStatusSharedProps {
  scope?: string;
}

const EditNotificationsCivilStatusShared = ({
  scope,
}: EditNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();
  const idCat = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return EditNotificationsCivilStatusCrumbs(baseUrl, idCat);
    }

    if (!scope) {
      return EditNotificationsCrumbs(baseUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return EditNotificationsSubscriptionCrumbs(baseUrl);
      case IdAmbito.Mutazioni:
        return EditNotificationsMutationCrumbs(baseUrl);
      case IdAmbito.Cancellazioni:
        return EditNotificationsCancellationsCrumbs(baseUrl);
      default:
        return [];
    }
  }, [scope, baseUrl, idCat]);

  return (
    <Fragment>
      <EditNotificationsShared items={items} baseUrl={baseUrl} />
    </Fragment>
  );
};

EditNotificationsCivilStatusShared.displayName = 'Edit Notifications Civil status shared component';

export default EditNotificationsCivilStatusShared;
